export default "__VITE_ASSET__66a42cdd__"